import { notification } from 'antd';
import { appApi } from 'services/api/api-instance';
import type {
  Calendar,
  CalendarWithPeriods,
  PeriodsQueryParams,
  UpdatePeriodsParams,
} from './types';

export const getCalendars = (): Promise<Calendar[]> => {
  return appApi
    .get('/calendars')
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить календари' });
      throw error;
    });
};

export const getPeriods = ({ calendarId }: PeriodsQueryParams): Promise<CalendarWithPeriods> => {
  return appApi
    .get(`/calendars/${calendarId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить периоды' });
      throw error;
    });
};

export const updatePeriods = ({ calendar }: UpdatePeriodsParams): Promise<CalendarWithPeriods> => {
  const transformedPeriods = calendar.periods.map((period) =>
    period.id > 0 ? period : { ...period, id: undefined },
  );
  return appApi
    .put(`/calendars/${calendar.id}`, {
      ...calendar,
      periods: transformedPeriods,
    })
    .then((res) => {
      notification.success({ message: 'Периоды успешно сохранены' });
      return res.data;
    })
    .catch((error) => {
      notification.error({
        message: error.response.data.message || 'Не удалось сохранить периоды',
      });
      throw error;
    });
};
